import { LinkElement } from '../models/link-element.model';
import { LinkGroup } from '../models/link-group.model';
import { Link } from '../models/link.model';
import { SelectedShape } from '../models/selected-shape.model';
import { BeforeSelectElementOnEditLink } from '../models/before-select-element-on-edit-link.model';
import { EditLink } from '../models/edit-link.model';
import { AfterRegisterLink } from '../models/after-register-link.model';

export function adjustCoordenateOfLinkElement(linkCompared: LinkElement, ajustedLink: LinkElement, group: LinkGroup, aditionFactor: number) {

    if (linkCompared.coordinates.x > ajustedLink.coordinates.x) {
      ajustedLink.coordinates.x += (ajustedLink.element.getBoundingClientRect().width / group.scale) + aditionFactor;
    } else {
      ajustedLink.coordinates.x -= aditionFactor;
    }
}

export function compareLinkElements(first: LinkElement, second: LinkElement, link: Link): boolean {
  return (link.first.element == first.element && link.second.element == second.element) ||
         (link.second.element == first.element && link.first.element == second.element);
}

//#region Utils

export function getVirtualElementByData(data: any, group: LinkGroup): LinkElement {
  return group.elements.find(value => compareObjects(value.data, data));
}

export function compareObjects(original, compare) {
  let isEqual = true;
  for (const [item, value] of Object.entries(original)) {
    if (original[item] !== compare[item]) {
      isEqual = false;
      break;
    }
  }

  return isEqual;
}

//#endregion

//#region Instance

export function createSelectedShapeInstance(link: Link, event: MouseEvent, linkElement: LinkElement = null): SelectedShape {
  return {
    event: event,
    link: link,
    linkElement: linkElement,
    shape : event.target
  };
}

export function getBeforeSelectElementOnEditLinkInstance(group: LinkGroup, selected: SelectedShape, newElm: LinkElement, oldElm: LinkElement): BeforeSelectElementOnEditLink {
  return {
    cancel: false,
    data: group.links,
    link: selected.link,
    newElement: newElm,
    oldElement: oldElm,
    originalElement: selected.linkElement
  };
}

export function getEditLinkInstance(group: LinkGroup, selected: SelectedShape, newLinkElement: LinkElement, oldElement: LinkElement): EditLink {
  return {
    data: group.links,
    link: selected.link,
    newElement: newLinkElement,
    oldElement: oldElement
  };
}

export function getAfterRegisterLinkInstance(link: Link, group: LinkGroup): AfterRegisterLink {
  return {
    currentLink: link,
    links: group.links
  };
}

export function getLinkInstance(dataFisrtElm: any, group: LinkGroup, dataSecondElm: any): Link {
  return {
    first: getVirtualElementByData(dataFisrtElm, group),
    second: getVirtualElementByData(dataSecondElm, group)
  };
}

//#endregion
